var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgCancel = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-1253 -449)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M-18756-3731a8.012,8.012,0,0,1,8-8,8.009,8.009,0,0,1,8,8,8,8,0,0,1-8,8A8.008,8.008,0,0,1-18756-3731Zm8,6a6,6,0,0,0,6-6,5.976,5.976,0,0,0-1.111-3.478l-8.359,8.364A5.965,5.965,0,0,0-18748-3725Zm-6-6a5.964,5.964,0,0,0,1.111,3.473l8.363-8.363A5.961,5.961,0,0,0-18748-3737,6.008,6.008,0,0,0-18754-3731Z",
  transform: "translate(20013 4192)"
}))));

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCancel, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/cancel.4035252b.svg";
export { ForwardRef as ReactComponent };